// Import Image
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar9 from "../../assets/images/users/avatar-9.jpg";
import avatar10 from "../../assets/images/users/avatar-10.jpg";

const contactData = [
    {
        id: 1,
        img: avatar1,
        name: "Danielle Wright",
        email: "danielle@example.com",
        phone: "+(380) 39 489 7330",
        country: "Ukraine",
        label: "Family",
        tab: "frequently",
    }, {
        id: 2,
        img: avatar2,
        name: "Stephen Bird",
        email: "stephen@example.com",
        phone: "+(907) 225-4144",
        country: "USA",
        label: "Imported",
        tab: "important",
    }, {
        id: 3,
        img: avatar3,
        name: "Jeffrey Hunt",
        email: "jeffrey@example.com",
        phone: "+(907) 694-7675",
        country: "USA",
        label: "Business",
        tab: "groups",
    }, {
        id: 4,
        img: avatar4,
        name: "Michael Brown",
        email: "michael@example.com",
        phone: "+(244) 948 701 110",
        country: "Angola",
        label: "Imported",
        tab: "trash",
    }, {
        id: 5,
        img: avatar5,
        name: "David Daly",
        email: "david@example.com",
        phone: "+(244) 948 701 110",
        country: "Angola",
        label: "Imported",
        tab: "frequently",
    }, {
        id: 6,
        img: avatar6,
        name: "Terry White",
        email: "terry@example.com",
        phone: "+(32) 493 33 65 89",
        country: "Belgium",
        label: "Family",
        tab: "groups",
    }, {
        id: 7,
        img: avatar7,
        name: "Daniel Gonzalez",
        email: "daniel@example.com",
        phone: "+(55) 93 90819-1376",
        country: "Brazil",
        label: "Business",
        tab: "groups",
    }, {
        id: 8,
        img: avatar8,
        name: "Stephen Garrison",
        email: "stephen@example.com",
        phone: "+(44) 7937 756071",
        country: "Jersey",
        label: "Family",
        tab: "frequently",
    }, {
        id: 9,
        img: avatar9,
        name: "Ashley Silva",
        email: "ashley@example.com",
        phone: "+(55) 21 92608-8982",
        country: "Brazil",
        label: "Friends",
        tab: "frequently",
    }, {
        id: 10,
        img: avatar10,
        name: "Charles Welch",
        email: "welch@example.com",
        phone: "+(264) 81 063 8558",
        country: "Namibia",
        label: "Friends",
        tab: "important",
    },
    {
        id: 11,
        img: avatar1,
        name: "Aaron Bauer",
        email: "aaron@example.com",
        phone: "+(34) 723 26 58 31",
        country: "Spain",
        label: "Imported",
        tab: "trash",
    },
    {
        id: 12,
        img: avatar2,
        name: "Heather Jimenez",
        email: "heather@example.com",
        phone: "+(380) 39 085 1057",
        country: "Ukraine",
        label: "Family",
        tab: "",
    },
    {
        id: 13,
        img: avatar3,
        name: "Scott Wilson",
        email: "scott@example.com",
        phone: "+(54) 9 3327 46-0897",
        country: "Argentina",
        label: "Friends",
        tab: "",
    }, {
        id: 14,
        img: avatar4,
        name: "James Wolfe",
        email: "wolfe@example.com",
        phone: "+(264) 60 778 1765",
        country: "Namibia",
        label: "Business",
        tab: "",
    }, {
        id: 15,
        img: avatar5,
        name: "Michelle Peterson",
        email: "michelle@example.com",
        phone: "+(244) 948 701 110",
        country: "Angola",
        label: "Imported",
        tab: "",
    }, {
        id: 16,
        img: avatar6,
        name: "Denise Bowers",
        email: "denise@example.com",
        phone: "+(32) 493 33 65 89",
        country: "Belgium",
        label: "Family",
        tab: "",
    }, {
        id: 17,
        img: avatar7,
        name: "William Hensley",
        email: "william@example.com",
        phone: "+(55) 22 95640-1280",
        country: "Brazil",
        label: "Business",
        tab: "",
    }, {
        id: 18,
        img: avatar8,
        name: "Sharon Brewer",
        email: "sharon@example.com",
        phone: "+(44) 7797 929140",
        country: "Jersey",
        label: "Family",
        tab: "",
    }, {
        id: 19,
        img: avatar9,
        name: "Barbara Nelson",
        email: "nelson@example.com",
        phone: "+(264) 85 162 8897",
        country: "Namibia",
        label: "Friends",
        tab: "",
    }, {
        id: 20,
        img: avatar10,
        name: "Victoria Medina",
        email: "victoria@example.com",
        phone: "+(264) 85 162 8897",
        country: "Namibia",
        label: "Friends",
        tab: "",
    }, {
        id: 21,
        img: avatar1,
        name: "Stacy Martin",
        email: "stacy@example.com",
        phone: "+(34) 590 60 09 06",
        country: "Spain",
        label: "Imported",
        tab: "",
    }, {
        id: 22,
        img: avatar2,
        name: "Leslie Fink",
        email: "leslie@example.com",
        phone: "+(55) 93 90819-1376",
        country: "Brazil",
        label: "Business",
        tab: "",
    }, {
        id: 23,
        img: avatar3,
        name: "Sean Walker",
        email: "sean@example.com",
        phone: "+(55) 93 90819-1376",
        country: "Brazil",
        label: "Business",
        tab: "",
    }, {
        id: 24,
        img: avatar4,
        name: "Kristen Gray",
        email: "gray@example.com",
        phone: "+(44) 7937 756071",
        country: "Jersey",
        label: "Family",
        tab: "frequently",
    }, {
        id: 25,
        img: avatar5,
        name: "Zachary Brown",
        email: "brown@example.com",
        phone: "+(55) 21 92608-8982",
        country: "Brazil",
        label: "Friends",
        tab: "important",
    }, {
        id: 26,
        img: avatar6,
        name: "Dana Trevino",
        email: "dana@example.com",
        phone: "+(264) 81 063 8558",
        country: "Namibia",
        label: "Friends",
        tab: "groups",
    }, {
        id: 27,
        img: avatar10,
        name: "Tonya Noble",
        email: "tonyanoble@hybrix.com",
        phone: "+(34) 414 453 5725",
        country: "Germany",
        label: "Business",
        tab: "trash",
    }
];

export { contactData }